import { useEffect, useState } from "react";

/**
 * Zwraca true, gdy użytkownik ma włączone "ogranicz ruch" w systemie.
 * Wszystkie efekty Tier 1 respektują tę preferencję:
 * - Lenis się nie uruchamia (natywny scroll),
 * - CountUp skacze od razu do wartości końcowej,
 * - reveale/grain/glow wygasza dodatkowo warstwa CSS w premium.css.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
